import React, { useState, useEffect } from 'react';
import {
  Box,
  Typography,
  Button,
  Tabs,
  Tab,
  Chip,
  Checkbox,
  FormControlLabel,
  Select,
  MenuItem,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Link,
  Fab,
  Alert,
  AlertTitle,
  Grid2
} from '@mui/material';
import {
  ErrorOutline as ErrorIcon,
  CasinoOutlined as PickRandomIcon,
  UnfoldMore as UnfoldMoreIcon,
  InfoOutlined as InfoIcon,
  NotInterested as NotInterestedIcon,
  Apps as ObjectiveIcon,
  Code as CodeIcon,
  Group as SolvedByIcon,
  ArticleOutlined as PrimerIcon,
  AccessTime as AttemptedIcon,
  BookmarkBorder as BookmarkIcon,
  HeadsetMic as SupportIcon,
  NewReleases as WhatsNewIcon,
} from '@mui/icons-material';
import { useDispatch, useSelector } from "react-redux";
import AllQuestions from 'Components/Classroom/ClassDetail/Questions/AllQuestions';
import QuestionDetail from 'Components/Classroom/ClassDetail/Questions/QuestionDetail';
import { getCourseAssignmentQuestions } from 'Slices/thunks';
import { useParams } from 'react-router-dom';
import Loader from 'Components/Common/Loader';

// --- Sample Data ---
const problemsData = [
  { day: 199, name: 'Captain Recommender', type: 'Objective', score: '0/75', solvedBy: 81 },
  { day: 199, name: 'Cosine Similarity Code', type: 'Code', score: '0/200', solvedBy: 79 },
  { day: 199, name: 'Content filtering characteristics', type: 'Objective', score: '0/50', solvedBy: 83 },
  { day: 199, name: 'Cold war', type: 'Objective', score: '0/75', solvedBy: 82 },
  { day: 190, name: 'Linear interpolation', type: 'Code', score: '0/300', solvedBy: 66 },
];

// --- Sub-components for better organization ---

const AlertBanner = () => {
  const { CourseScore, Translation } = useSelector((state) => ({
    CourseScore: state.Course.courseScore || {},
    Translation: state.Translation.translation?.Course || {},
  }));

  return (
    <Alert
      severity="error"
      icon={<ErrorIcon fontSize="medium" />}
      // action={
      //   <Button
      //     variant="contained"
      //     startIcon={<PickRandomIcon />}
      //     sx={{ textTransform: 'none', borderRadius: '8px', boxShadow: 'none' }}
      //   >
      //     Pick Random
      //   </Button>
      // }
      sx={{ backgroundColor: 'background.default', color: "secondary.main", borderRadius: '8px', alignItems: 'center', mb: 2, fontSize: '16px', fontWeight: 700 }}
    >
      {Translation?.YourProblemSolvingPercentage} <Typography component="span" color="error.main" fontWeight="bold">{CourseScore?.ProblemSolvedPercentage}</Typography>, {Translation?.ShouldMoreThan}
      <Typography variant="body2" color="secondary.light" fontWeight={600}>{Translation?.CompleteUnsolvedProblems}</Typography>
    </Alert>
  );
} 

const FilterSelect = ({ label }) => (
  <Select
    defaultValue="all"
    size="small"
    sx={{
        p: 0,
      minWidth: 150,
      fontSize: '14px',
      borderRadius: '8px',
      bgcolor: 'background.default',
      '& .MuiOutlinedInput-notchedOutline': { border: 'none' },
    }}
  >
    <MenuItem value="all">{label}</MenuItem>
  </Select>
);

const ProblemFilters = () => {

  const { Translation } = useSelector((state) => ({
    Translation: state.Translation.translation?.Course || {},
  }));

  return (
    <Box>
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, alignItems: 'center' }}>
        <FormControlLabel control={<Checkbox defaultChecked />} label={`Assignment 971`} />
        <FormControlLabel control={<Checkbox />} label="Additional Problems 388" />
        <FilterSelect label="Topic" />
        <FilterSelect label="Level of Difficulty" />
        <FilterSelect label="Filter by Type" />
        {/* <FormControlLabel control={<Checkbox />} label="Show Primer" /> */}
        <FormControlLabel control={<Checkbox />} label="Show Bookmarked" />
      </Box>
      <Typography variant="caption" color="secondary.light" sx={{ display: 'block', my: 2 }} fontWeight={500}>
        {Translation?.HintsPenaltyFree} 🎉
      </Typography>
    </Box>
  )
};

// const ProblemsTable = () => (
//   <TableContainer component={Paper} sx={{ boxShadow: 'none', border: '1px solid background.default', borderRadius: '8px' }}>
//     <Table sx={{ minWidth: 650 }} aria-label="problems table">
//       <TableHead>
//         <TableRow sx={{ bgcolor: 'background.default' }}>
//           <TableCell>Day <UnfoldMoreIcon sx={{ fontSize: 16, verticalAlign: 'middle' }} /></TableCell>
//           <TableCell>Name of the Problem <UnfoldMoreIcon sx={{ fontSize: 16, verticalAlign: 'middle' }} /></TableCell>
//           <TableCell>Topic <Link href="#" underline="hover" sx={{ fontSize: '0.75rem' }}>Show</Link></TableCell>
//           <TableCell>Difficulty <Link href="#" underline="hover" sx={{ fontSize: '0.75rem' }}>Show</Link></TableCell>
//           <TableCell>Type <UnfoldMoreIcon sx={{ fontSize: 16, verticalAlign: 'middle' }} /></TableCell>
//           <TableCell>Score <UnfoldMoreIcon sx={{ fontSize: 16, verticalAlign: 'middle' }} /></TableCell>
//           <TableCell>Solved By <InfoIcon sx={{ fontSize: 16, verticalAlign: 'middle' }} /> <UnfoldMoreIcon sx={{ fontSize: 16, verticalAlign: 'middle' }} /></TableCell>
//           <TableCell>Actions <UnfoldMoreIcon sx={{ fontSize: 16, verticalAlign: 'middle' }} /></TableCell>
//         </TableRow>
//       </TableHead>
//       <TableBody>
//         {problemsData.map((row) => (
//           <TableRow key={row.name} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
//             <TableCell>{`Day ${row.day}`}</TableCell>
//             <TableCell component="th" scope="row">{row.name}</TableCell>
//             <TableCell><NotInterestedIcon sx={{ color: 'text.disabled' }} /></TableCell>
//             <TableCell><NotInterestedIcon sx={{ color: 'text.disabled' }} /></TableCell>
//             <TableCell>
//               <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                 {row.type === 'Objective' ? <ObjectiveIcon sx={{ color: 'text.secondary' }} /> : <CodeIcon sx={{ color: 'text.secondary' }} />}
//                 {row.type}
//               </Box>
//             </TableCell>
//             <TableCell>{row.score}</TableCell>
//             <TableCell>
//               <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
//                 <SolvedByIcon sx={{ color: 'text.secondary' }} />
//                 {row.solvedBy}
//               </Box>
//             </TableCell>
//             <TableCell>
//               <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                 <PrimerIcon sx={{ color: 'text.secondary', cursor: 'pointer' }} />
//                 <Chip
//                   icon={<AttemptedIcon />}
//                   label="Attempted"
//                   size="small"
//                   sx={{ bgcolor: '#FFF3E0', color: '#E65100' }}
//                 />
//                 <Button variant="contained" size="small" sx={{ textTransform: 'none', boxShadow: 'none' }}>Solve</Button>
//                 <BookmarkIcon sx={{ color: 'text.secondary', cursor: 'pointer' }} />
//               </Box>
//             </TableCell>
//           </TableRow>
//         ))}
//       </TableBody>
//     </Table>
//   </TableContainer>
// );

// --- Main Page Component ---
const ProblemsPage = () => {
  const dispatch = useDispatch();
  const [tabValue, setTabValue] = useState(1);
  const [selectedQue, setSelectedQue] = useState(0);
  const [questions, setQuestions] = useState([]);

  const { CourseScore, Questions, isLoading, Translation } = useSelector((state) => ({
    CourseScore: state.Course.courseScore || {},
    Questions: state.Assignment.questions || [],
    isLoading: state.Assignment.isLoading,
    Translation: state.Translation.translation?.Course || {},
  }));

  const handleTabChange = (event, newValue) => {
    if (newValue === 2) {
      const filterQuestions = Questions.filter((q) => !q.IsSelectedOptionCorrect)
      setQuestions(filterQuestions)
      
    } else if (newValue === 3) {
      const filterQuestions = Questions.filter((q) => q.IsSelectedOptionCorrect)
      setQuestions(filterQuestions)

    } else {
      setQuestions(Questions);
    }
    setTabValue(newValue);
    setSelectedQue();
  };
  
  const StyledTab = ({ label, count, bgColor }) => (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      {label}
      <Chip label={count} size="small" sx={{ bgcolor: bgColor, color: 'white.main', fontWeight: 'bold' }} />
    </Box>
  );

  useEffect(() => {
    const courseId = localStorage.getItem("CourseID");
    if (courseId) {
      dispatch(getCourseAssignmentQuestions({CourseID: courseId}))
    }

  }, [])

  useEffect(() => {
    setQuestions(Questions);

  }, [Questions])

  return (
    isLoading ? 
    <Loader /> :
    <Box sx={{ p: 3, bgcolor: 'white', position: 'relative' }}>
      { CourseScore?.ProblemSolvedPercentage < 70 &&
        <AlertBanner />
      }
      
      <Box sx={{ borderBottom: 1, borderColor: 'divider', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Tabs value={tabValue} onChange={handleTabChange}>
          <Tab value={1} label={<StyledTab label={Translation?.AllProblems} count={Questions?.length} bgColor="primary.main" />} />
          <Tab value={2} label={<StyledTab label={Translation?.Unsolved} count={(Questions || []).filter((q) => !q.IsSelectedOptionCorrect).length} bgColor="error.main" />} />
          <Tab value={3} label={<StyledTab label={Translation?.Solved} count={(Questions || []).filter((q) => q.IsSelectedOptionCorrect).length} bgColor="success.main" />} />
          {/* <Tab label="Skill Tests" sx={{ textTransform: 'none' }} /> */}
        </Tabs>
        <Link href="#" underline="hover" sx={{ display: 'flex', alignItems: 'center', gap: 0.5, color: 'text.secondary', textDecoration: 'none' }}>
            <WhatsNewIcon sx={{color: '#FFB300'}} /> {Translation?.WhatsNew}
        </Link>
      </Box>

      <Box sx={{ pt: 2 }}>
        {/* <ProblemFilters setQuestions={setQuestions} /> */}
        {/* <ProblemsTable /> */}
        {/* {selectedQue == 0 ? <AllQuestions setSelectedQue={setSelectedQue} questions={Questions} /> : <QuestionDetail question={Questions[selectedQue - 1]} totalQuestions={Questions?.length || 0} selectedQue={selectedQue} setSelectedQue={setSelectedQue} />} */}
      </Box>

      <Grid2 display={"flex"} flexDirection={"column"} gap="20px">
        {!selectedQue ? <AllQuestions setSelectedQue={setSelectedQue} questions={questions} /> : <QuestionDetail question={questions[selectedQue - 1]} totalQuestions={questions?.length || 0} selectedQue={selectedQue} setSelectedQue={setSelectedQue} isScore={true} />}
      </Grid2>
    </Box>
  );
};

export default ProblemsPage;